export default __webpack_public_path__ + "static/media/Eagle-logo (2).88e4083a.png";